import {useCallback, useState} from "react";
import {
  DEFAULT_LIVE_MAP_DISPLAY,
  LIVE_MAP_DISPLAY_STORAGE_KEY,
  type LiveMapDisplayOptions,
  readLiveMapDisplay,
  saveLiveMapDisplay,
} from "./live-map-display";

export type UseLiveMapDisplayOptions = {
  storageKey?: string;
  /** This app's defaults, for anything the browser has not saved. */
  defaults?: LiveMapDisplayOptions;
};

/** The live map display options, saved per browser under `storageKey`. */
export const useLiveMapDisplay = ({
  storageKey = LIVE_MAP_DISPLAY_STORAGE_KEY,
  defaults = DEFAULT_LIVE_MAP_DISPLAY,
}: UseLiveMapDisplayOptions = {}) => {
  const [display, setDisplay] = useState(() => readLiveMapDisplay(storageKey, defaults));
  const onDisplayChange = useCallback((next: LiveMapDisplayOptions) => {
    setDisplay(next);
    saveLiveMapDisplay(next, storageKey);
  }, [storageKey]);
  return {display, onDisplayChange};
};
